exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transaction-info-icon[data-v-2b586316] {\n    font-size: .60em;\n    font-weight: bold;\n}\n.nav-tabs > li > a.nav-link.active[data-v-2b586316]  {\n    font-weight: bold;\n    background-color: #fff;\n}\n.nav-tabs > li > a[data-v-2b586316] {\n  background-color: #dedede;\n  border-color: #fff;\n}\n", ""]);

// exports
